import { useMainContext } from '@contexts/Contexts';
import { TermFilter } from './components/TermFilter';
import { getAvailableTerms } from '@utils/TalksUtils';
import { useEffect } from 'react';

const FilterList = () => {
	const { state, dispatch } = useMainContext();
	const {
		filters,
		error,
		selectedDay,
		selectedVenue,
		selectedCatsTags,
		filteredTalks,
	} = state;

	const catsAvailable = getAvailableTerms(filteredTalks, 'talk_category');
	const tagsAvailable = getAvailableTerms(filteredTalks, 'talk_tag');
	const available = catsAvailable.concat(tagsAvailable);

	// Check if if all selectedCatsTags are in the available array
	const selectedCatsTagsFiltered = available.filter((item) => {
		return selectedCatsTags.includes(item);
	});

	// Here we create a new filter array and elimintae the categories and filters that are not valid on the current selection
	useEffect(() => {
		if (selectedCatsTags.length !== selectedCatsTagsFiltered.length) {
			dispatch({
				type: 'SET_SELECTED_CAT_TAG_FILTERS',
				payload: selectedCatsTagsFiltered,
			});
		}
	}, [selectedCatsTagsFiltered]); // eslint-disable-line react-hooks/exhaustive-deps

	const {
		days = [],
		tags = [],
		categories = [],
		allowedTags = [],
		allowedCategories = [],
	} = filters;

	if (error) {
		return <p>Error filters: {error.message}</p>;
	}

	const onDaySelect = (event) => {
		const selectedDayId = parseInt(event.target.value);
		const selectedDayData = days.filter(
			(day) => day.term_id === selectedDayId,
		);

		/**
		 * Construct the query that will be used when a day is selected
		 *
		 * @type {{query: [{taxonomy: string, term_id: number}]}}
		 */
		const queryData = {
			query: [
				{
					taxonomy: 'talk_day',
					term_id: selectedDayId,
				},
			],
		};

		/**
		 * Check if selected day has venues and select the first venue term_id.
		 * If venues array is empty set the selected venue to empty array
		 */
		if (selectedDayData[0].venues.length > 0) {
			const firstVenue = selectedDayData[0].venues[0].term_id;
			dispatch({
				type: 'SET_SELECTED_VENUE',
				payload: [firstVenue],
			});

			// Add venue to query.
			queryData.query.push({
				taxonomy: 'talk_venue',
				term_id: firstVenue,
			});
		} else {
			dispatch({
				type: 'SET_SELECTED_VENUE',
				payload: [],
			});
		}

		dispatch({
			type: 'SET_SELECTED_DAY',
			payload: [event.target.value],
		});

		dispatch({
			type: 'SET_QUERY',
			payload: queryData,
		});
	};

	const onVenueSelect = (event) => {
		const eventValue = parseInt(event.target.value);

		// Query that will be used when a day and venue is selected
		const query = {
			query: [
				{
					taxonomy: 'talk_day',
					term_id: parseInt(selectedDay[0]),
				},
				{
					taxonomy: 'talk_venue',
					term_id: eventValue,
				},
			],
		};

		// Check if we have a selected venue
		const found = selectedVenue.find((item) => item === eventValue);

		// If the event value is the same that the existing venue filter value clear the venue filter and just use the default day filter
		if (found) {
			dispatch({
				type: 'SET_SELECTED_VENUE',
				payload: [],
			});
			dispatch({
				type: 'SET_QUERY',
				payload: {
					query: [
						{
							taxonomy: 'talk_day',
							term_id: parseInt(selectedDay[0]),
						},
					],
				},
			});
			// If we don't have a selected day, add it and query talks using the new query
		} else {
			dispatch({
				type: 'SET_SELECTED_VENUE',
				payload: [eventValue],
			});

			dispatch({
				type: 'SET_QUERY',
				payload: query,
			});
		}
	};

	const Venues = () => {
		const currentDay = days.filter(
			(day) => day.term_id === parseInt(selectedDay[0]),
		);

		const venueList = [];
		if (currentDay.length > 0) {
			currentDay[0].venues.forEach((venue = { term_id: '0' }, index) => {
				const isChecked = !!selectedVenue.find(
					(item) => parseInt(item) === venue.term_id,
				);
				venueList.push(
					<div className="cfs-filters__item" key={index}>
						<input
							className="cfs-filters__item-input"
							type="checkbox"
							id={venue.term_id}
							value={venue.term_id ? venue.term_id : 0}
							checked={isChecked}
							onChange={onVenueSelect}
						/>
						<label
							className="cfs-filters__item-label"
							htmlFor={venue.term_id}
						>
							<span className="item-name">{venue.name}</span>
							{venue.location && (
								<span className="item-location">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 384 512"
									>
										<path d="M272 192C272 236.2 236.2 272 192 272C147.8 272 112 236.2 112 192C112 147.8 147.8 112 192 112C236.2 112 272 147.8 272 192zM192 240C218.5 240 240 218.5 240 192C240 165.5 218.5 144 192 144C165.5 144 144 165.5 144 192C144 218.5 165.5 240 192 240zM384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384zM192 32C103.6 32 32 103.6 32 192C32 207.6 37.43 229 48.56 255.4C59.47 281.3 74.8 309.4 92.14 337.5C126.2 392.8 166.6 445.7 192 477.6C217.4 445.7 257.8 392.8 291.9 337.5C309.2 309.4 324.5 281.3 335.4 255.4C346.6 229 352 207.6 352 192C352 103.6 280.4 32 192 32z" />
									</svg>{' '}
									{venue.location}
								</span>
							)}
						</label>
					</div>,
				);
			});
		}
		return venueList;
	};

	const Categories = () => {
		const cats = selectedCatsTags?.length ? [...selectedCatsTags] : [];
		return (
			<TermFilter
				taxonomy="talk_category"
				terms={categories}
				allowed={allowedCategories}
				selected={cats}
				onClick={(selection) => {
					// If the selection is already in the cats array remove it
					if (cats.includes(selection)) {
						cats.splice(cats.indexOf(selection), 1);
					} else {
						cats.push(selection);
					}

					dispatch({
						type: 'SET_SELECTED_CAT_TAG_FILTERS',
						payload: cats,
					});
				}}
			/>
		);
	};

	const Tags = () => {
		const tagList = selectedCatsTags?.length ? [...selectedCatsTags] : [];

		return (
			<TermFilter
				taxonomy="talk_tag"
				terms={tags}
				allowed={allowedTags}
				selected={tagList}
				onClick={(selection) => {
					// If the selection is already in the cats array remove it
					if (tagList.includes(selection)) {
						tagList.splice(tagList.indexOf(selection), 1);
					} else {
						tagList.push(selection);
					}

					dispatch({
						type: 'SET_SELECTED_CAT_TAG_FILTERS',
						payload: tagList,
					});
				}}
			/>
		);
	};

	const Days = days.map((day = { term_id: '0' }) => {
		const isChecked = !!selectedDay.find(
			(item) => parseInt(item) === day.term_id,
		);
		return (
			<li className="cfs-filters__item" key={day.term_id}>
				<input
					className="cfs-filters__item-input"
					type="checkbox"
					id={day.term_id}
					name={day.name}
					value={day.term_id}
					onChange={onDaySelect}
					checked={isChecked}
				/>
				<label
					className="cfs-filters__item-label"
					htmlFor={day.term_id}
				>
					<span className="item-name">{day.name}</span>
				</label>
			</li>
		);
	});
	return (
		<div className="cfs-filters">
			<div className="cfs-filters-section-one">
				<ul className="cfs-filters__main">{Days}</ul>
				<div className="cfs-filters__secondary">
					<Venues />
				</div>
			</div>
			{allowedCategories.length > 0 && (
				<div className="cfs-filters-section-two">
					<div className="cfs-filters__category category-filter">
						<Categories />
					</div>
				</div>
			)}
			{allowedTags.length > 0 && (
				<div className="cfs-filters-section-three">
					<div className="cfs-filters__category category-filter">
						<Tags />
					</div>
				</div>
			)}
		</div>
	);
};

const Filters = () => {
	return <FilterList />;
};

export default Filters;
